// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiArray from "lumi-array/lib/es6/src/LumiArray.res.js";
import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as LumiResult from "lumi-rescript/lib/es6/src/LumiResult.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as M23f$Linear from "lumi-linear/lib/es6/src/M23f.res.js";
import * as StringCodec from "lumi-rescript/lib/es6/src/StringCodec.res.js";
import * as Rectf$Linear from "lumi-linear/lib/es6/src/Rectf.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Belt_MapString from "@rescript/runtime/lib/es6/Belt_MapString.js";
import * as Circlef$Linear from "lumi-linear/lib/es6/src/Circlef.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BoundingBox$Linear from "lumi-linear/lib/es6/src/BoundingBox.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as LineSegmentf$Linear from "lumi-linear/lib/es6/src/LineSegmentf.res.js";
import * as Camera$LumiDocuments from "./Camera.res.js";
import * as Sensor$LumiDocuments from "./Sensor.res.js";
import * as Display$LumiDocuments from "./Display.res.js";
import * as Indicator$LumiDocuments from "./Indicator.res.js";

let jsonCodec = Jzon.object2(param => [
  param.name,
  param.index
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    index: param[1]
  }
}), Jzon.field("name", Jzon.string), Jzon.field("index", Jzon.int));

function sortKey(info) {
  return [
    info.index,
    info.name
  ];
}

let FacilityMapInfo = {
  jsonCodec: jsonCodec,
  sortKey: sortKey
};

let jsonCodec$1 = LumiJzon.inlineRecordSum(shape => {
  switch (shape.TAG) {
    case "Rectangle" :
      return [
        "Rectangle",
        [
          [
            "x",
            LumiJzon.encodeFloat(shape.x)
          ],
          [
            "y",
            LumiJzon.encodeFloat(shape.y)
          ],
          [
            "width",
            LumiJzon.encodeFloat(shape.width)
          ],
          [
            "height",
            LumiJzon.encodeFloat(shape.height)
          ]
        ]
      ];
    case "Circle" :
      return [
        "Circle",
        [
          [
            "cx",
            LumiJzon.encodeFloat(shape.cx)
          ],
          [
            "cy",
            LumiJzon.encodeFloat(shape.cy)
          ],
          [
            "r",
            LumiJzon.encodeFloat(shape.r)
          ]
        ]
      ];
    case "Ellipse" :
      return [
        "Ellipse",
        [
          [
            "cx",
            LumiJzon.encodeFloat(shape.cx)
          ],
          [
            "cy",
            LumiJzon.encodeFloat(shape.cy)
          ],
          [
            "rx",
            LumiJzon.encodeFloat(shape.rx)
          ],
          [
            "ry",
            LumiJzon.encodeFloat(shape.ry)
          ]
        ]
      ];
    case "Line" :
      return [
        "Line",
        [
          [
            "x1",
            LumiJzon.encodeFloat(shape.x1)
          ],
          [
            "y1",
            LumiJzon.encodeFloat(shape.y1)
          ],
          [
            "x2",
            LumiJzon.encodeFloat(shape.x2)
          ],
          [
            "y2",
            LumiJzon.encodeFloat(shape.y2)
          ]
        ]
      ];
    case "Polyline" :
      return [
        "Polyline",
        [[
            "points",
            Jzon.encodeWith(shape.points, Jzon.array(V2f$Linear.jsonCodec))
          ]]
      ];
    case "Polygon" :
      return [
        "Polygon",
        [[
            "points",
            Jzon.encodeWith(shape.points, Jzon.array(V2f$Linear.jsonCodec))
          ]]
      ];
    case "Path" :
      return [
        "Path",
        [
          [
            "d",
            LumiJzon.encodeString(shape.d)
          ],
          [
            "polys",
            Jzon.encodeWith(shape.polys, Jzon.array(Jzon.array(V2f$Linear.jsonCodec)))
          ]
        ]
      ];
    case "TextS" :
      return [
        "TextS",
        [
          [
            "x",
            LumiJzon.encodeFloat(shape.x)
          ],
          [
            "y",
            LumiJzon.encodeFloat(shape.y)
          ],
          [
            "text",
            LumiJzon.encodeString(shape.text)
          ]
        ]
      ];
  }
}, (tag, fields) => {
  switch (tag) {
    case "Circle" :
      return Stdlib_Result.map(LumiResult.sequence3([
        LumiJzon.decodeField(fields, "cx", Jzon.float),
        LumiJzon.decodeField(fields, "cy", Jzon.float),
        LumiJzon.decodeField(fields, "r", Jzon.float)
      ]), param => ({
        TAG: "Circle",
        cx: param[0],
        cy: param[1],
        r: param[2]
      }));
    case "Ellipse" :
      return Stdlib_Result.map(LumiResult.sequence4([
        LumiJzon.decodeField(fields, "cx", Jzon.float),
        LumiJzon.decodeField(fields, "cy", Jzon.float),
        LumiJzon.decodeField(fields, "rx", Jzon.float),
        LumiJzon.decodeField(fields, "ry", Jzon.float)
      ]), param => ({
        TAG: "Ellipse",
        cx: param[0],
        cy: param[1],
        rx: param[2],
        ry: param[3]
      }));
    case "Line" :
      return Stdlib_Result.map(LumiResult.sequence4([
        LumiJzon.decodeField(fields, "x1", Jzon.float),
        LumiJzon.decodeField(fields, "y1", Jzon.float),
        LumiJzon.decodeField(fields, "x2", Jzon.float),
        LumiJzon.decodeField(fields, "y2", Jzon.float)
      ]), param => ({
        TAG: "Line",
        x1: param[0],
        y1: param[1],
        x2: param[2],
        y2: param[3]
      }));
    case "Path" :
      return Stdlib_Result.map(LumiResult.sequence2([
        LumiJzon.decodeField(fields, "d", Jzon.string),
        LumiJzon.decodeField(fields, "polys", Jzon.array(Jzon.array(V2f$Linear.jsonCodec)))
      ]), param => ({
        TAG: "Path",
        d: param[0],
        polys: param[1]
      }));
    case "Polygon" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "points", Jzon.array(V2f$Linear.jsonCodec)), points => ({
        TAG: "Polygon",
        points: points
      }));
    case "Polyline" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "points", Jzon.array(V2f$Linear.jsonCodec)), points => ({
        TAG: "Polyline",
        points: points
      }));
    case "Rectangle" :
      return Stdlib_Result.map(LumiResult.sequence4([
        LumiJzon.decodeField(fields, "x", Jzon.float),
        LumiJzon.decodeField(fields, "y", Jzon.float),
        LumiJzon.decodeField(fields, "width", Jzon.float),
        LumiJzon.decodeField(fields, "height", Jzon.float)
      ]), param => ({
        TAG: "Rectangle",
        x: param[0],
        y: param[1],
        width: param[2],
        height: param[3]
      }));
    case "TextS" :
      return Stdlib_Result.map(LumiResult.sequence3([
        LumiJzon.decodeField(fields, "x", Jzon.float),
        LumiJzon.decodeField(fields, "y", Jzon.float),
        LumiJzon.decodeField(fields, "text", Jzon.string)
      ]), param => ({
        TAG: "TextS",
        x: param[0],
        y: param[1],
        text: param[2]
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined);

function toPoints(shape) {
  switch (shape.TAG) {
    case "Rectangle" :
      let height = shape.height;
      let width = shape.width;
      let y = shape.y;
      let x = shape.x;
      return [
        [
          x,
          y
        ],
        [
          x + width,
          y
        ],
        [
          x + width,
          y + height
        ],
        [
          x,
          y + height
        ]
      ];
    case "Circle" :
      let r = shape.r;
      let cy = shape.cy;
      let cx = shape.cx;
      return [
        [
          cx - r,
          cy
        ],
        [
          cx + r,
          cy
        ],
        [
          cx,
          cy - r
        ],
        [
          cx,
          cy + r
        ]
      ];
    case "Ellipse" :
      let ry = shape.ry;
      let rx = shape.rx;
      let cy$1 = shape.cy;
      let cx$1 = shape.cx;
      return [
        [
          cx$1 - rx,
          cy$1
        ],
        [
          cx$1 + rx,
          cy$1
        ],
        [
          cx$1,
          cy$1 - ry
        ],
        [
          cx$1,
          cy$1 + ry
        ]
      ];
    case "Line" :
      return [
        [
          shape.x1,
          shape.y1
        ],
        [
          shape.x2,
          shape.y2
        ]
      ];
    case "Polyline" :
    case "Polygon" :
      return shape.points;
    case "Path" :
      return shape.polys.flat();
    case "TextS" :
      return [[
          shape.x,
          shape.y
        ]];
  }
}

function toLines(shape) {
  let polyToLines = points => LumiArray.adjacentPairs(points).map(param => ({
    from: param[0],
    to: param[1]
  }));
  if (shape.TAG === "Path") {
    return shape.polys.flatMap(polyToLines);
  } else {
    return polyToLines(toPoints(shape));
  }
}

function center(shape) {
  switch (shape.TAG) {
    case "Rectangle" :
      return Rectf$Linear.center({
        pos: [
          shape.x,
          shape.y
        ],
        size: [
          shape.width,
          shape.height
        ]
      });
    case "Circle" :
    case "Ellipse" :
      return [
        shape.cx,
        shape.cy
      ];
    case "Line" :
      let p1_0 = shape.x1;
      let p1_1 = shape.y1;
      let p1 = [
        p1_0,
        p1_1
      ];
      let p2_0 = shape.x2;
      let p2_1 = shape.y2;
      let p2 = [
        p2_0,
        p2_1
      ];
      let r = V2f$Linear.minus(p2, p1);
      return V2f$Linear.plus(p1, V2f$Linear.scale(r, 0.5));
    case "Polyline" :
    case "Polygon" :
      return Rectf$Linear.center(BoundingBox$Linear.axisAlignedBoundingBox(shape.points));
    case "Path" :
      let points = shape.polys.flat();
      return Rectf$Linear.center(BoundingBox$Linear.axisAlignedBoundingBox(points));
    case "TextS" :
      return [
        shape.x,
        shape.y
      ];
  }
}

function intersectLine(shape, line) {
  switch (shape.TAG) {
    case "Circle" :
      return LineSegmentf$Linear.intersectCircle(line, {
        pos: [
          shape.cx,
          shape.cy
        ],
        radius: shape.r
      });
    case "Path" :
    case "TextS" :
      return false;
    default:
      let lines = toLines(shape);
      return lines.some(__x => LineSegmentf$Linear.intersectLine(line, __x));
  }
}

function intersectCircle(shape, circle) {
  switch (shape.TAG) {
    case "Circle" :
      return Circlef$Linear.intersectCircle(circle, {
        pos: [
          shape.cx,
          shape.cy
        ],
        radius: shape.r
      });
    case "TextS" :
      return false;
    default:
      let lines = toLines(shape);
      return lines.some(__x => LineSegmentf$Linear.intersectCircle(__x, circle));
  }
}

function FacilityMap$Shape(props) {
  let __renderPathPolygons = props.renderPathPolygons;
  let __vectorEffect = props.vectorEffect;
  let style = props.style;
  let className = props.className;
  let shape = props.shape;
  let vectorEffect = __vectorEffect !== undefined ? __vectorEffect : "non-scaling-stroke";
  let renderPathPolygons = __renderPathPolygons !== undefined ? __renderPathPolygons : false;
  let renderPolygon = (points, key, extraClassName) => {
    let points$1 = points.map(point => {
      let match = V2$Linear.map(point, __x => __x.toString());
      return match[0] + `,` + match[1];
    }).join(" ");
    let className$1 = Stdlib_Option.mapOr(className, extraClassName, c => Stdlib_Option.mapOr(extraClassName, c, e => c + " " + e));
    return JsxRuntime.jsx("polygon", {
      className: className$1,
      style: style,
      points: points$1,
      vectorEffect: vectorEffect
    }, key !== undefined ? Primitive_option.valFromOption(key) : undefined);
  };
  switch (shape.TAG) {
    case "Rectangle" :
      let x = shape.x.toString();
      let y = shape.y.toString();
      let width = shape.width.toString();
      let height = shape.height.toString();
      return JsxRuntime.jsx("rect", {
        className: className,
        style: style,
        height: height,
        width: width,
        vectorEffect: vectorEffect,
        x: x,
        y: y
      });
    case "Circle" :
      let cx = shape.cx.toString();
      let cy = shape.cy.toString();
      let r = shape.r.toString();
      return JsxRuntime.jsx("circle", {
        className: className,
        style: style,
        cx: cx,
        cy: cy,
        r: r,
        vectorEffect: vectorEffect
      });
    case "Ellipse" :
      let cx$1 = shape.cx.toString();
      let cy$1 = shape.cy.toString();
      let rx = shape.rx.toString();
      let ry = shape.ry.toString();
      return JsxRuntime.jsx("ellipse", {
        className: className,
        style: style,
        cx: cx$1,
        cy: cy$1,
        rx: rx,
        ry: ry,
        vectorEffect: vectorEffect
      });
    case "Line" :
      let x1 = shape.x1.toString();
      let y1 = shape.y1.toString();
      let x2 = shape.x2.toString();
      let y2 = shape.y2.toString();
      return JsxRuntime.jsx("line", {
        className: className,
        style: style,
        vectorEffect: vectorEffect,
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
      });
    case "Polyline" :
      let points = shape.points.map(point => {
        let match = V2$Linear.map(point, __x => __x.toString());
        return match[0] + `,` + match[1];
      }).join(" ");
      return JsxRuntime.jsx("polyline", {
        className: className,
        style: style,
        points: points,
        vectorEffect: vectorEffect
      });
    case "Polygon" :
      return renderPolygon(shape.points, undefined, undefined);
    case "Path" :
      let d = shape.d;
      if (renderPathPolygons) {
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("path", {
              className: className,
              style: style,
              d: d,
              vectorEffect: vectorEffect
            }),
            shape.polys.map((poly, polyIx) => renderPolygon(poly, polyIx.toString(), "path-polygon"))
          ]
        });
      } else {
        return JsxRuntime.jsx("path", {
          className: className,
          style: style,
          d: d,
          vectorEffect: vectorEffect
        });
      }
    case "TextS" :
      let x$1 = shape.x.toString();
      let y$1 = shape.y.toString();
      return JsxRuntime.jsx("text", {
        children: shape.text,
        className: className,
        style: style,
        vectorEffect: vectorEffect,
        x: x$1,
        y: y$1
      });
  }
}

let Shape = {
  jsonCodec: jsonCodec$1,
  toPoints: toPoints,
  toLines: toLines,
  center: center,
  intersectLine: intersectLine,
  intersectCircle: intersectCircle,
  make: FacilityMap$Shape
};

let options = [
  "Floor",
  "Dirt",
  "Grass",
  "Road",
  "Sidewalk"
];

let stringCodec = StringCodec.anySumAsString(options, undefined);

let jsonCodec$2 = LumiJzon.stringCodec(stringCodec);

let FloorType = {
  options: options,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec$2
};

let options$1 = [
  "Ramp",
  "Stairs",
  "Treadmill"
];

let stringCodec$1 = StringCodec.anySumAsString(options$1, undefined);

let jsonCodec$3 = LumiJzon.stringCodec(stringCodec$1);

let SlopeType = {
  options: options$1,
  stringCodec: stringCodec$1,
  jsonCodec: jsonCodec$3
};

let options$2 = [
  "Floor",
  "FloorDirt",
  "FloorGrass",
  "FloorRoad",
  "FloorSidewalk",
  "NegativeSpace",
  "Wall",
  "Door",
  "Area",
  "SlopeRamp",
  "SlopeStairs",
  "SlopeTreadmill",
  "Elevator",
  "FloorMarking",
  "ParkingPlace",
  "Camera",
  "Display",
  "Indicator",
  "Tree",
  "StreetLight"
];

let cmp = Primitive_object.compare;

let Cmp = Belt_Id.MakeComparable({
  cmp: cmp
});

function toDrawingOrder(objectTypeEnum) {
  switch (objectTypeEnum) {
    case "Floor" :
      return 3;
    case "FloorDirt" :
      return 1;
    case "FloorGrass" :
      return 2;
    case "FloorRoad" :
      return 4;
    case "FloorSidewalk" :
      return 5;
    case "NegativeSpace" :
      return 8;
    case "Wall" :
      return 12;
    case "Door" :
      return 13;
    case "Area" :
      return 6;
    case "SlopeRamp" :
      return 10;
    case "SlopeStairs" :
      return 9;
    case "SlopeTreadmill" :
      return 11;
    case "Elevator" :
      return 14;
    case "FloorMarking" :
      return 7;
    case "ParkingPlace" :
      return 17;
    case "Camera" :
      return 18;
    case "Display" :
      return 19;
    case "Indicator" :
      return 20;
    case "Tree" :
      return 16;
    case "StreetLight" :
      return 15;
  }
}

let stringCodec$2 = StringCodec.anySumAsString(options$2, prim => prim.toLowerCase());

function className(objectTypeEnum) {
  return "object-" + stringCodec$2.toString(objectTypeEnum);
}

let Enum = {
  options: options$2,
  Cmp: Cmp,
  toDrawingOrder: toDrawingOrder,
  stringCodec: stringCodec$2,
  className: className
};

function toEnum(objectType) {
  switch (objectType.TAG) {
    case "Floor" :
      switch (objectType.floor) {
        case "Floor" :
          return "Floor";
        case "Dirt" :
          return "FloorDirt";
        case "Grass" :
          return "FloorGrass";
        case "Road" :
          return "FloorRoad";
        case "Sidewalk" :
          return "FloorSidewalk";
      }
    case "NegativeSpace" :
      return "NegativeSpace";
    case "Wall" :
      return "Wall";
    case "Door" :
      return "Door";
    case "Area" :
      return "Area";
    case "Slope" :
      switch (objectType.slope) {
        case "Ramp" :
          return "SlopeRamp";
        case "Stairs" :
          return "SlopeStairs";
        case "Treadmill" :
          return "SlopeTreadmill";
      }
    case "Elevator" :
      return "Elevator";
    case "FloorMarking" :
      return "FloorMarking";
    case "ParkingPlace" :
      return "ParkingPlace";
    case "Camera" :
      return "Camera";
    case "Display" :
      return "Display";
    case "Indicator" :
      return "Indicator";
    case "Tree" :
      return "Tree";
    case "StreetLight" :
      return "StreetLight";
  }
}

let jsonCodec$4 = LumiJzon.inlineRecordSum(objectType => {
  switch (objectType.TAG) {
    case "Floor" :
      return [
        "Floor",
        [
          [
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ],
          [
            "floor",
            Jzon.encodeWith(objectType.floor, jsonCodec$2)
          ]
        ]
      ];
    case "NegativeSpace" :
      return [
        "NegativeSpace",
        [[
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ]]
      ];
    case "Wall" :
      return [
        "Wall",
        [[
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ]]
      ];
    case "Door" :
      return [
        "Door",
        [[
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ]]
      ];
    case "Area" :
      return [
        "Area",
        [
          [
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ],
          [
            "name",
            LumiJzon.encodeString(objectType.name)
          ]
        ]
      ];
    case "Slope" :
      return [
        "Slope",
        [
          [
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ],
          [
            "slope",
            Jzon.encodeWith(objectType.slope, jsonCodec$3)
          ],
          [
            "linkedMap",
            Jzon.encodeWith(objectType.linkedMap, Jzon.nullable(Document$LumiStore.Key.jsonCodec()))
          ]
        ]
      ];
    case "Elevator" :
      return [
        "Elevator",
        [[
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ]]
      ];
    case "FloorMarking" :
      return [
        "FloorMarking",
        [[
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ]]
      ];
    case "ParkingPlace" :
      return [
        "ParkingPlace",
        [
          [
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ],
          [
            "linkedSensor",
            Jzon.encodeWith(objectType.linkedSensor, Jzon.nullable(Document$LumiStore.Key.jsonCodec()))
          ]
        ]
      ];
    case "Camera" :
      return [
        "Camera",
        [[
            "linkedCamera",
            Jzon.encodeWith(objectType.linkedCamera, Jzon.nullable(Document$LumiStore.Key.jsonCodec()))
          ]]
      ];
    case "Display" :
      return [
        "Display",
        [[
            "linkedDisplay",
            Jzon.encodeWith(objectType.linkedDisplay, Jzon.nullable(Document$LumiStore.Key.jsonCodec()))
          ]]
      ];
    case "Indicator" :
      return [
        "Indicator",
        [[
            "linkedIndicator",
            Jzon.encodeWith(objectType.linkedIndicator, Jzon.nullable(Document$LumiStore.Key.jsonCodec()))
          ]]
      ];
    case "Tree" :
      return [
        "Tree",
        [[
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ]]
      ];
    case "StreetLight" :
      return [
        "StreetLight",
        [[
            "shape",
            Jzon.encodeWith(objectType.shape, jsonCodec$1)
          ]]
      ];
  }
}, (tag, fields) => {
  switch (tag) {
    case "Area" :
      return Stdlib_Result.map(LumiResult.sequence2([
        LumiJzon.decodeField(fields, "shape", jsonCodec$1),
        LumiJzon.decodeField(fields, "name", Jzon.string)
      ]), param => ({
        TAG: "Area",
        shape: param[0],
        name: param[1]
      }));
    case "Camera" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "linkedCamera", Jzon.nullable(Document$LumiStore.Key.jsonCodec())), linkedCamera => ({
        TAG: "Camera",
        linkedCamera: linkedCamera
      }));
    case "Display" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "linkedDisplay", Jzon.nullable(Document$LumiStore.Key.jsonCodec())), linkedDisplay => ({
        TAG: "Display",
        linkedDisplay: linkedDisplay
      }));
    case "Door" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "shape", jsonCodec$1), shape => ({
        TAG: "Door",
        shape: shape
      }));
    case "Elevator" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "shape", jsonCodec$1), shape => ({
        TAG: "Elevator",
        shape: shape
      }));
    case "Floor" :
      return Stdlib_Result.map(LumiResult.sequence2([
        LumiJzon.decodeField(fields, "shape", jsonCodec$1),
        LumiJzon.decodeField(fields, "floor", jsonCodec$2)
      ]), param => ({
        TAG: "Floor",
        shape: param[0],
        floor: param[1]
      }));
    case "FloorMarking" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "shape", jsonCodec$1), shape => ({
        TAG: "FloorMarking",
        shape: shape
      }));
    case "Indicator" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "linkedIndicator", Jzon.nullable(Document$LumiStore.Key.jsonCodec())), linkedIndicator => ({
        TAG: "Indicator",
        linkedIndicator: linkedIndicator
      }));
    case "NegativeSpace" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "shape", jsonCodec$1), shape => ({
        TAG: "NegativeSpace",
        shape: shape
      }));
    case "ParkingPlace" :
      return Stdlib_Result.map(LumiResult.sequence2([
        LumiJzon.decodeField(fields, "shape", jsonCodec$1),
        LumiJzon.decodeField(fields, "linkedSensor", Jzon.nullable(Document$LumiStore.Key.jsonCodec()))
      ]), param => ({
        TAG: "ParkingPlace",
        shape: param[0],
        linkedSensor: param[1]
      }));
    case "Slope" :
      return Stdlib_Result.map(LumiResult.sequence3([
        LumiJzon.decodeField(fields, "shape", jsonCodec$1),
        LumiJzon.decodeField(fields, "slope", jsonCodec$3),
        LumiJzon.decodeField(fields, "linkedMap", Jzon.nullable(Document$LumiStore.Key.jsonCodec()))
      ]), param => ({
        TAG: "Slope",
        shape: param[0],
        slope: param[1],
        linkedMap: param[2]
      }));
    case "StreetLight" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "shape", jsonCodec$1), shape => ({
        TAG: "StreetLight",
        shape: shape
      }));
    case "Tree" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "shape", jsonCodec$1), shape => ({
        TAG: "Tree",
        shape: shape
      }));
    case "Wall" :
      return Stdlib_Result.map(LumiJzon.decodeField(fields, "shape", jsonCodec$1), shape => ({
        TAG: "Wall",
        shape: shape
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined);

function toDrawingOrder$1(objectType) {
  return toDrawingOrder(toEnum(objectType));
}

function toShape(objectType, cameraShape, displayShape, indicatorShape) {
  switch (objectType.TAG) {
    case "Camera" :
      return cameraShape;
    case "Display" :
      return displayShape;
    case "Indicator" :
      return indicatorShape;
    default:
      return objectType.shape;
  }
}

function toPoints$1(objectType) {
  switch (objectType.TAG) {
    case "Camera" :
    case "Display" :
    case "Indicator" :
      return [V2f$Linear.zero];
    default:
      return Stdlib_Option.mapOr(toShape(objectType, undefined, undefined, undefined), [], toPoints);
  }
}

let ObjectType = {
  Enum: Enum,
  toEnum: toEnum,
  jsonCodec: jsonCodec$4,
  toDrawingOrder: toDrawingOrder$1,
  toShape: toShape,
  toPoints: toPoints$1
};

let jsonCodec$5 = Jzon.object2(param => [
  param.transform,
  param.objectType
], param => ({
  TAG: "Ok",
  _0: {
    transform: param[0],
    objectType: param[1]
  }
}), Jzon.field("transform", M23f$Linear.jsonCodec), Jzon.field("objectType", jsonCodec$4));

function toPoints$2(obj) {
  return toPoints$1(obj.objectType).map(point => Transform$Linear.M23f.apply(point, obj.transform));
}

function intersectLine$1(object, line, cameraShape, displayShape, indicatorShape) {
  let invTransform = M23f$Linear.inverse(object.transform);
  let transformedLine = Transform$Linear.M23f.transformLine(invTransform, line);
  return Stdlib_Option.mapOr(toShape(object.objectType, cameraShape, displayShape, indicatorShape), false, shape => intersectLine(shape, transformedLine));
}

function center$1(object, cameraShape, displayShape, indicatorShape) {
  return Stdlib_Option.map(toShape(object.objectType, cameraShape, displayShape, indicatorShape), s => Transform$Linear.M23f.apply(center(s), object.transform));
}

let $$Object = {
  jsonCodec: jsonCodec$5,
  toPoints: toPoints$2,
  intersectLine: intersectLine$1,
  center: center$1
};

let jsonCodec$6 = Jzon.object3(param => [
  param.name,
  param.scale,
  param.objects
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    scale: param[1],
    objects: param[2]
  }
}), Jzon.field("name", Jzon.string), Jzon.field("scale", Jzon.nullable(Jzon.float)), Jzon.field("objects", LumiJzon.mapString(jsonCodec$5)));

function addIndicators(facilityMap, indicators) {
  let cameraIndicators = Camera$LumiDocuments.Schema.$$Map.fromArray(Stdlib_Array.filterMap(Indicator$LumiDocuments.Schema.$$Map.toArray(indicators), param => {
    let match = param[1].type_;
    switch (match.TAG) {
      case "IndicatorTypeLumicam" :
        return [
          match._1,
          param[0]
        ];
      case "IndicatorTypeWaylight" :
      case "IndicatorTypeZigbee" :
        return;
    }
  }));
  let newIndicatorObjects = Belt_MapString.fromArray(Stdlib_Array.filterMap(Belt_MapString.toArray(facilityMap.objects), param => {
    let object = param[1];
    let svgId = param[0];
    let match = object.objectType;
    if (match.TAG !== "Camera") {
      return;
    }
    let cameraKey = match.linkedCamera;
    if (cameraKey !== undefined) {
      return Stdlib_Option.map(Camera$LumiDocuments.Schema.$$Map.get(cameraIndicators, cameraKey), indicatorKey => {
        let newIndicatorObject_transform = object.transform;
        let newIndicatorObject_objectType = {
          TAG: "Indicator",
          linkedIndicator: indicatorKey
        };
        let newIndicatorObject = {
          transform: newIndicatorObject_transform,
          objectType: newIndicatorObject_objectType
        };
        return [
          svgId + "-artifical-indicator",
          newIndicatorObject
        ];
      });
    }
  }));
  let objects = Belt_MapString.merge(facilityMap.objects, newIndicatorObjects, (param, a, b) => Stdlib_Option.orElse(a, b));
  return {
    name: facilityMap.name,
    scale: facilityMap.scale,
    objects: objects
  };
}

function axisAlignedBoundingBox(facilityMap) {
  return BoundingBox$Linear.axisAlignedBoundingBox(Belt_MapString.valuesToArray(facilityMap.objects).flatMap(toPoints$2));
}

function linkedSensorKeySet(facilityMap) {
  return Sensor$LumiDocuments.Schema.$$Set.fromArray(Stdlib_Array.filterMap(Belt_MapString.valuesToArray(facilityMap.objects), object => {
    let match = object.objectType;
    if (match.TAG === "ParkingPlace") {
      return match.linkedSensor;
    }
  }));
}

function linkedCameraKeySet(facilityMap) {
  return Camera$LumiDocuments.Schema.$$Set.fromArray(Stdlib_Array.filterMap(Belt_MapString.valuesToArray(facilityMap.objects), object => {
    let match = object.objectType;
    if (match.TAG === "Camera") {
      return match.linkedCamera;
    }
  }));
}

function linkedDisplayKeySet(facilityMap) {
  return Display$LumiDocuments.Schema.$$Set.fromArray(Stdlib_Array.filterMap(Belt_MapString.valuesToArray(facilityMap.objects), object => {
    let match = object.objectType;
    if (match.TAG === "Display") {
      return match.linkedDisplay;
    }
  }));
}

function linkedIndicatorKeySet(facilityMap) {
  return Indicator$LumiDocuments.Schema.$$Set.fromArray(Stdlib_Array.filterMap(Belt_MapString.valuesToArray(facilityMap.objects), object => {
    let match = object.objectType;
    if (match.TAG === "Indicator") {
      return match.linkedIndicator;
    }
  }));
}

let FacilityMap = {
  jsonCodec: jsonCodec$6,
  addIndicators: addIndicators,
  axisAlignedBoundingBox: axisAlignedBoundingBox,
  linkedSensorKeySet: linkedSensorKeySet,
  linkedCameraKeySet: linkedCameraKeySet,
  linkedDisplayKeySet: linkedDisplayKeySet,
  linkedIndicatorKeySet: linkedIndicatorKeySet
};

function documentName(param) {
  return param.name;
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "facility-map",
  jsonCodec: jsonCodec$6,
  icon: "map-location",
  readOnly: false
});

function linkedFacilityMapKeySet(facilityMap) {
  return Schema.$$Set.fromArray(Stdlib_Array.filterMap(Belt_MapString.valuesToArray(facilityMap.objects), object => {
    let match = object.objectType;
    if (match.TAG === "Slope") {
      return Stdlib_Option.map(match.linkedMap, Document$LumiStore.Key.coerce);
    }
  }));
}

let SvgIdMap;

export {
  FacilityMapInfo,
  Shape,
  FloorType,
  SlopeType,
  ObjectType,
  $$Object,
  SvgIdMap,
  FacilityMap,
  Schema,
  linkedFacilityMapKeySet,
}
/* jsonCodec Not a pure module */
